import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    templateUrl: './voltage.component.html',
    standalone: false
})
export class InstallationVoltagePluginComponent {
  public voltages: any[];
  public config: any;
  public editRoute = ['installation', 'voltage', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.voltages = this.config.Voltages;
  }
}
PluginComponent.plugins['installationvoltage'] = InstallationVoltagePluginComponent;
